import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DynamicBanner from "../../Pages/include/DynamicBanner";
import api from "../../../api";

const FacultyList = () => {
  const { miniSlug, slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- 1. Fetch Data Dynamicallly ---
  useEffect(() => {
    const fetchData = async () => {
      if (!miniSlug || !slug) return;

      try {
        setLoading(true);
        // Construct dynamic URL based on params
        // Example: /api/schoolsandcollege/schoolofphysiotherapy/faculty-list
        const url = `/api/${miniSlug}/${slug}/faculty-list`;

        const response = await api.get(url);

        // Handle response structure
        if (response.data) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching faculty data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [miniSlug, slug]);

  // --- 2. Helper for Image URLs ---
  const getImageUrl = (path) => {
    if (!path) return "/assets/images/dummy-img.png"; // Fallback
    if (path.startsWith("http")) return path;

    // Prepend your backend domain to storage paths
    // Adjust this base URL to match your server
    const BASE_URL = process.env.REACT_APP_API_URL;
    // Ensure we don't double slash if path already has it
    return `${BASE_URL}/public${path.startsWith("/") ? "" : "/"}${path}`;
  };

  // --- 3. Loading & Error States ---
  if (loading)
    return <div className="text-center py-5">Loading Faculty Data...</div>;
  if (!data)
    return <div className="text-center py-5">No Faculty Data Found</div>;

  // --- 4. Banner Data Prep ---
  // JSON Structure: data.banner.desktop[] / data.banner.mobile[]

  const bannerImage = data.banner?.desktop?.[0]
    ? `${data.banner.desktop[0]}`
    : "/assets/images/default-banner.webp";

  const bannerImageMobile = data.banner?.mobile?.[0]
    ? `${data.banner.mobile[0]}`
    : "/assets/images/default-banner.webp";
  // JSON Structure: data.name is the heading
  const bannerTitle = data.name || "Faculty Members";

  return (
    <>
      <DynamicBanner
        title={bannerTitle}
        bgImage={bannerImage}
        bgImageMobile={bannerImageMobile}
      />

      <section className="faculty_section">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{data.title || "Faculty Members"}</h2>
          </div>

          {/* Map through the dynamic 'groups' array */}
          {data.groups && data.groups.length > 0 ? (
            data.groups.map((group, gIndex) => (
              <div key={group.id || gIndex} className="mb-5">
                {/* Group Title (Mapped from 'title' in API) */}
                <div className="d-flex justify-content-center">
                  <h3 className="faculty-role-heading mb-4">{group.title}</h3>
                </div>

                {/* Members Grid */}
                <div className="row d-flex justify-content-center">
                  {group.members &&
                    group.members.map((member, mIndex) => (
                      <div
                        className="col-lg-4 col-md-6 col-12 mb-5"
                        key={mIndex}
                      >
                        {/* 🔒 EXACT CARD STRUCTURE FROM YOUR EXISTING CODE */}
                        <div className="single-faculty-item text-center">
                          <div className="faculty-wrapper-alumni mb-3">
                            <img
                              className="img-fluid facluty-main-image"
                              src={getImageUrl(member.image)}
                              alt={member.name}
                              loading="lazy"
                            />
                          </div>

                          <h1 className="faculty-title">{member.name}</h1>

                          <p className="faculty-designation">
                            {member.designation}
                          </p>
                        </div>
                        {/* 🔒 END CARD STRUCTURE */}
                      </div>
                    ))}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">No faculty groups available.</div>
          )}
        </div>
      </section>
    </>
  );
};

export default FacultyList;
